import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { BeatLoader } from "react-spinners";
import { TypeAnimation } from "react-type-animation";

const Subscription = () => {
   const [loading, setLoading] = useState(false);

   const handleSubscribe = (e) => {
      e.preventDefault();
      const email = e.target.email.value;

      if (!email) {
         toast.error("Please! Enter your email to Subscribe");
         return;
      }

      setLoading(true);
      fetch("https://recycle-hut-server.vercel.app/subscribers", {
         method: "POST",
         headers: {
            "content-type": "application/json",
         },
         body: JSON.stringify({ email }),
      })
         .then((res) => res.json())
         .then((data) => {
            setLoading(false);
            if (data.acknowledged) {
               toast.success(
                  "Subscription added successfully. Thank you for subscribing"
               );
               e.target.reset();
            } else {
               toast.error(data.message);
               e.target.reset();
            }
         })
         .catch((err) => toast.error(err.message));
   };

   return (
      <div>
         <form onSubmit={handleSubscribe}>
            <div className="grid md:grid-cols-3 gird-cols-1 gap-4 justify-center items-center">
               <div className="md:ml-auto md:mb-6">
                  <p className="">
                     <strong>
                        <TypeAnimation
                           sequence={["Subscribe to Recycle Hut...", 3000]}
                           speed={40}
                           cursor={true}
                           repeat={Infinity}
                        />
                     </strong>
                  </p>
               </div>

               <div className="md:mb-6 my-transition-4">
                  <input
                     type="email"
                     name="email"
                     className="
                    hover:rounded-full
                form-control
                block
                w-full
                px-3
                py-1.5
                text-base
                font-normal
                text-gray-700
                bg-white bg-clip-padding
                border border-solid border-gray-300
                rounded
                transition
                ease-in-out
                m-0
                focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                     id="exampleFormControlInput1"
                     placeholder="Email address"
                  />
               </div>

               <div className="md:mr-auto mb-6">
                  <button
                     type="submit"
                     className="rounded inline-block px-6 py-2 border-2 border-white text-white font-medium text-xs leading-tight uppercase hover:bg-black hover:bg-opacity-5 focus:outline-none focus:ring-0 transition duration-150 ease-in-out hover:font-bold hover:rounded-full my-transition-9"
                  >
                     <div className="flex justify-center items-center">
                        {loading ? (
                           <BeatLoader color="#fff" size="10" speedMultiplier=".6" />
                        ) : (
                           "Subscribe"
                        )}
                     </div>
                  </button>
               </div>
            </div>
         </form>
      </div>
   );
};

export default Subscription;
